import _ from 'lodash';
import React, { PropTypes } from 'react';
import Helmet from 'react-helmet';
import { SliderPicker } from 'react-color';

import { icon } from './../../icons/icons';

const Preferences = (props) => {
    const { app, template, templates, actions } = props;

    const goBack = () => {
        actions.setWidgetTools('general');
    };

    const setAppName = (e) => {
        actions.setAppName(e.target.value);
    };

    const setPrimaryColor = (color) => {
        actions.setPrimaryColor(color.hex);
    };

    const resetPrimaryColor = () => {
        actions.setPrimaryColor(null);
    };

    const setSecondaryColor = (color) => {
        actions.setSecondaryColor(color.hex);
    };

    const resetSecondaryColor = () => {
        actions.setSecondaryColor(null);
    };

    const changeTemplate = (event) => {
        actions.setTemplateId(parseInt(event.target.value, 10));
    };

    return (
        <div className="option">
            <Helmet
                style={[{
                    cssText: `
                        .content:before {
                            background-color: ${app.secondaryColor};
                        }
                        .nav-btns__next {
                            color: ${app.primaryColor} !important;
                        }
                    `,
                }]}
            />

            <h3 className="option__header">Preferences</h3>
            <div className="option__back" onClick={goBack} title="Back">{icon.backArrow()}</div>

            <div className="prefs__row">
                <label>Choose template:</label>
                { (app.mode !== 'CLIENT') ?
                    <select onChange={changeTemplate}>
                        { _.map(templates, (template) => <option key={template.id} value={template.id}>{ template.name }</option>) }
                    </select>
                : null }
            </div>

            <div className="prefs__row">
                <label>Project name:</label>
                <input type="text" defaultValue={app.name} placeholder="Project name ..." onChange={setAppName} />
            </div>
            <br />
            <div className="prefs__row">
                <label className="prefs__label">
                    <span className="prefs__desc">Primary color:</span>
                    <span className="prefs__reset" onClick={resetPrimaryColor}>Reset</span>
                </label>
                <SliderPicker
                    color={(app.primaryColor) ? app.primaryColor : template.primaryColor}
                    onChangeComplete={setPrimaryColor}
                />
            </div>
            <div className="prefs__row">
                <label className="prefs__label">
                    <span className="prefs__desc">Secondary color:</span>
                    <span className="prefs__reset" onClick={resetSecondaryColor}>Reset</span>
                </label>
                <SliderPicker
                    color={(app.secondaryColor) ? app.secondaryColor : template.secondaryColor}
                    onChangeComplete={setSecondaryColor}
                />
            </div>
        </div>
    );
};

Preferences.propTypes = {
    app: PropTypes.object.isRequired,
    template: PropTypes.object.isRequired,
    templates: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
};

export default Preferences;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Tools/Preferences.jsx